const LargeGridIcon = ( ) => {
	return (
		<div className={ 'qec-grid-icon qec-grid-icon--large' }>
			<span className="qec-grid-icon__item"></span>
			<span className="qec-grid-icon__item"></span>
			<span className="qec-grid-icon__item"></span>
			<span className="qec-grid-icon__item"></span>
			<span className="qec-grid-icon__item"></span>
			<span className="qec-grid-icon__item"></span>
			<span className="qec-grid-icon__item"></span>
			<span className="qec-grid-icon__item"></span>
			<span className="qec-grid-icon__item"></span>
		</div>
	);
};

export default LargeGridIcon;
